const privacyTR = {
  seo: {
    title: "Gizlilik Politikası | QuadroCode",
    description:
      "QuadroCode gizlilik politikasını inceleyin: hangi verileri topladığımız, bunları nasıl kullandığımız ve bize nasıl ulaşabileceğiniz.",
  },
  hero: {
    eyebrow: "Gizlilik ve veri işlemleri",
    title: "Gizlilik Politikası",
    intro:
      "Bu sayfa, www.quadrocode.com adresini ziyaret ettiğinizde QuadroCode'un bilgileri nasıl topladığını, kullandığını, paylaştığını ve koruduğunu açıklar.",
    effectiveDateLabel: "Yürürlük tarihi",
    updatedLabel: "Son güncelleme",
    effectiveDate: "1 Mart 2026",
    updatedDate: "1 Mart 2026",
    websiteLabel: "Web sitesi",
    websiteValue: "www.quadrocode.com",
    contactLabel: "Gizlilik iletişim",
    contactValue: "info@quadrocode.com",
  },
  jumpLabel: "Bölüme git",
  quickFacts: [
    {
      icon: "shield",
      title: "Kişisel veri satılmaz",
      text: "Kişisel bilgileriniz satılmaz.",
    },
    {
      icon: "cookie",
      title: "Çerez kullanımı",
      text: "Trafik ve tercih analizi için çerezler ve analiz araçları kullanılabilir.",
    },
    {
      icon: "rights",
      title: "Haklarınız",
      text: "Uygulanabildiği durumlarda erişim, düzeltme, silme veya onayı geri çekme talebinde bulunabilirsiniz.",
    },
  ],
  sections: [
    {
      id: "introduction",
      number: "01",
      title: "Giriş",
      icon: "document",
      paragraphs: [
        'QuadroCode ("Şirket", "biz") olarak, www.quadrocode.com adresini ziyaret ettiğinizde bilgilerinizin nasıl toplandığını, kullanıldığını, açıklandığını ve korunduğunu bu politika ile açıklıyoruz.',
        "Bu politikanın şartlarını kabul etmiyorsanız lütfen web sitesine erişmeyin.",
      ],
    },
    {
      id: "information-we-collect",
      number: "02",
      title: "Toplanan Bilgiler",
      icon: "globe",
      subsections: [
        {
          title: "Kişisel Bilgiler",
          items: [
            "Ad soyad",
            "E-posta adresi",
            "Telefon numarası",
            "Şirket adı",
            "Formlar üzerinden iletilen proje detayları",
            "Gönüllü olarak paylaştığınız diğer bilgiler",
          ],
        },
        {
          title: "Otomatik Olarak Toplanan Bilgiler",
          items: [
            "IP adresi",
            "Tarayıcı türü",
            "Cihaz bilgileri",
            "Ziyaret edilen sayfalar",
            "Sayfalarda geçirilen süre",
            "Yönlendirme kaynakları",
          ],
          note: "Bu veriler çerezler ve analiz araçları ile toplanabilir.",
        },
      ],
    },
    {
      id: "how-we-use-information",
      number: "03",
      title: "Bilgilerin Kullanımı",
      icon: "usage",
      items: [
        "Sorulara yanıt vermek",
        "Proje teklifleri ve danışmanlık sunmak",
        "Hizmetlerimizi geliştirmek",
        "Web sitesi performansını analiz etmek",
        "Onay verilmiş ise güncellemeler veya tekliflerle iletişime geçmek",
        "Site güvenliğini sağlamak",
      ],
    },
    {
      id: "cookies",
      number: "04",
      title: "Çerezler ve Takip Teknolojileri",
      icon: "cookie",
      paragraphs: ["Çerezler ve benzer teknolojiler şu amaçlarla kullanılır:"],
      items: ["Kullanıcı deneyimini iyileştirmek", "Trafik analizi yapmak", "Tercihleri hatırlamak"],
      note: "Çerezleri tarayıcı ayarlarınızdan devre dışı bırakabilirsiniz.",
    },
    {
      id: "sharing",
      number: "05",
      title: "Bilgi Paylaşımı",
      icon: "lock",
      paragraphs: ["Kişisel bilgileriniz satılmaz."],
      preface: "Veriler şu taraflarla paylaşılabilir:",
      items: [
        "Hosting sağlayıcıları",
        "Google Analytics gibi analiz sağlayıcıları",
        "Gerekliyse ödeme işleyicileri",
        "Yasal zorunluluk halinde resmi makamlar",
      ],
    },
    {
      id: "retention",
      number: "06",
      title: "Veri Saklama",
      icon: "shield",
      paragraphs: ["Kişisel veriler yalnızca şu nedenlerle gerekli olduğu sürece saklanır:"],
      items: ["Ticari amaçlar", "Yasal uyumluluk", "Sözleşmesel yükümlülükler"],
    },
    {
      id: "security",
      number: "07",
      title: "Veri Güvenliği",
      icon: "lock",
      paragraphs: [
        "Verilerinizi korumak için teknik ve organizasyonel önlemler uyguluyoruz. Ancak internet üzerinden iletim hiçbir zaman yüzde 100 güvenli değildir.",
      ],
    },
    {
      id: "rights",
      number: "08",
      title: "Haklarınız",
      icon: "rights",
      paragraphs: ["Bulunduğunuz yargı alanına göre şu haklara sahip olabilirsiniz:"],
      items: [
        "Verilerinize erişim",
        "Düzeltme talebi",
        "Silme talebi",
        "Onayı geri çekme",
        "İşleme itiraz etme",
      ],
      note: "Haklarınızı kullanmak için info@quadrocode.com adresiyle iletişime geçin.",
    },
    {
      id: "third-party-links",
      number: "09",
      title: "Üçüncü Taraf Bağlantıları",
      icon: "globe",
      paragraphs: [
        "Web sitemiz üçüncü taraf sitelere bağlantılar içerebilir. Bu sitelerin gizlilik uygulamalarından sorumlu değiliz.",
      ],
    },
    {
      id: "changes",
      number: "10",
      title: "Politika Değişiklikleri",
      icon: "document",
      paragraphs: ["Bu politika zaman zaman güncellenebilir. Değişiklikler bu sayfada yayınlanır."],
    },
    {
      id: "contact-information",
      number: "11",
      title: "İletişim Bilgileri",
      icon: "mail",
      contactCard: {
        company: "Quadrocode LTD",
        addressLines: ["UK, Suite 402, Level 4, Newford", "UK"],
        email: "info@quadrocode.com",
      },
    },
  ],
  backHome: "Ana sayfaya dön",
};

export default privacyTR;
